import { styled, SxProp, useSx } from 'dripsy';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { View } from 'react-native';

import { IS_WEB } from '@utils';
import { IListViewProps, ListView } from '../views/ListView';
import { Separator } from '../common/Separator';
import { UserItem } from './UserItem';
import type { User } from '@models/Viewer/UserModel';

const columnWrapperStyle: SxProp = {
  flex: 1,
  justifyContent: 'flex-start',
};

interface IItemContainerProps {
  isLastRowItem: boolean;
  numColumns: number;
}

const ItemContainer = styled(View)((props: IItemContainerProps) => ({
  flex: 1 / props.numColumns,
  pr: props.isLastRowItem ? '$0' : ['$6', '$8'],
}));

interface IUserListProps
  extends Omit<IListViewProps<User>, 'renderItem'> {
  data: User[];
  onPress(item: User): void;
}

export const UserList = observer(
  ({
    data,
    onPress,
    numColumns = IS_WEB ? 6 : 3,
    ...props
  }: IUserListProps) => {
    const sx = useSx();

    return (
      <ListView<User>
        keyExtractor={(i) => i.id.toString()}
        numColumns={numColumns}
        columnWrapperStyle={sx(columnWrapperStyle)}
        data={data}
        renderItem={({ item, index }) => (
          <ItemContainer
            numColumns={numColumns}
            isLastRowItem={(index + 1) % numColumns === 0}
          >
            <UserItem item={item} onPress={onPress} />
          </ItemContainer>
        )}
        ListHeaderComponent={() => <Separator size="$8" />}
        ItemSeparatorComponent={() => <Separator size="$8" />}
        {...props}
      />
    );
  },
);
